import { render, staticRenderFns } from "./SkeletonCourseVideoDetails.vue?vue&type=template&id=0edc5f30&scoped=true"
import script from "./SkeletonCourseVideoDetails.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseVideoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc5f30",
  null
  
)

export default component.exports